import { XButton, XButtonGroup } from './xbutton';
import { XIcon } from './xicon';

export const install = function (app) {
    app.component(XIcon.name, XIcon);
    app.component(XButton.name, XButton);
    app.component(XButtonGroup.name, XButtonGroup);
};

export {
    XButtonGroup,
    XButton,
    XIcon,
};
